var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHillsideRainy = function SvgHillsideRainy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 462,
    height: 118,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90AF4E",
    d: "M148 0C-25.417 0-72 33.25-166 96.103c0 0 89.5 21.897 314 21.897s314-21.897 314-21.897C365.5 38.523 321.417 0 148 0"
  })));
};
export default SvgHillsideRainy;